import React, { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';

import { sortingType } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { Select } from '../../../../common/select';
import { useSortButtons } from './sort-buttons/use-sort-buttons';
import { SortingTypes } from './ecp-sort.models';
import { useStyles } from './ecp-sort.styles';

export const EcpSort = (): JSX.Element => {
  const currentSortingType = useReactiveVar(sortingType);
  const options = useSortButtons();
  const classes = useStyles();

  const handleSort = useCallback((): void => {
    sortingType(currentSortingType === SortingTypes.distance ? SortingTypes.rating : SortingTypes.distance);
  }, [sortingType, currentSortingType]);

  const renderValue = (value: unknown) => {
    const option = options.find((o) => o.value === value);
    return option?.selectedLabel ?? option?.label ?? null;
  };

  return (
    <Select
      fullWidth
      options={options}
      value={currentSortingType}
      onChange={handleSort}
      renderValue={renderValue}
      formControlClasses={classes.select}
      itemStyles={classes.selectMenuItem}
    />
  );
};
